export default "__VITE_ASSET__C98LMRdu__"